<template>
  <div>

    <success :rowid="$route.params.rowid" :cont="$route.params.cont" :cust="$route.params.cust" :roleID="this.role"
             v-if="showSuccess"/>

    <div v-if="canceledLink == 0">
      <h3 class="text-center col-10 offset-1 mt-5">
        <span>ელ.პოლისის ლინკი გაუქმებულია</span> <br/>
        თქვენი სადაზღვევო მრჩეველია - {{ data.policyInfo[0].nmG_NAME_A }} {{ data.policyInfo[0].mnG_LASTNAME }}<br/>
        მობ: {{ data.policyInfo[0].mnG_PHONE }}<br/>
        ელ.ფოსტა: {{ data.policyInfo[0].mnG_EMAIL }}
      </h3>
    </div>
    <div v-if="statusApprove == 1 && canceledLink == 1">
      <h3 class="text-center col-10 offset-1 mt-5">
        <span>ელ.პოლისის ლინკი უკვე დადასტურებულია</span> <br/>
        თქვენი სადაზღვევო მრჩეველია - {{ data.policyInfo[0].nmG_NAME_A }} {{ data.policyInfo[0].mnG_LASTNAME }}<br/>
        მობ: {{ data.policyInfo[0].mnG_PHONE }}<br/>
        ელ.ფოსტა: {{ data.policyInfo[0].mnG_EMAIL }}
      </h3>
    </div>

    <table v-if="statusApprove == 0 && !showSuccess && canceledLink == 1">
      <thead id="print-header">
      <div class="d-md-flex pt-md-4 p-0 pb-4">
        <div class="header_logo_property"></div>
        <div class="p-0 sm-text md-text" style="background-color: #E0E0E0">
          <div style="" class="header-text nino-mtavruli">ქონების საკრედიტო დაზღვევის პოლისი</div>
        </div>
      </div>
      </thead>

      <tbody class="print-body">
      <div class="loader">
        <div class="square-spin">
          <div><img src="../assets/img/A-White.svg"></div>
        </div>
      </div>
      <div class="col-sm-11 pr-2">
        <div class="form-font p-md-0 offset-sm-1">
          <div class="p-md-0 ">
            <b-col cols="12" offset="0" class="">
              <b-row>

                <!--Insurer-->

                <b-col md="3" sm="12" class="description-top pt-2   nino-mtavruli " style="font-size:17px">პოლისის
                  ნომერი
                </b-col>
                <b-col md="9" sm="12" class="p-2" style="background-color: #E0E0E0">
                  <div class="text-center">
                    <div class="pol-number">{{ data.policyInfo[0].policyInsuranceProduct }}</div>
                  </div>
                </b-col>
                <b-col md="12" sm="12" class="p-2 content-header mt-2">
                  <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli"> მზღვეველი</div>
                </b-col>
                <b-col md="3" sm="12" class="description p-2  pl-3">დასახელება</b-col>
                <b-col md="9" sm="12" class="value-background p-2 ">
                  <div class="text-center pl-3">
                    <div>სს "არდი დაზღვევა"</div>
                  </div>
                </b-col>
                <b-col md="3" sm="12" class="description p-2  pl-3">ს.კ</b-col>
                <b-col md="9" sm="12" class="value-background p-2 ">
                  <div class="text-center">

                    <div>ს|კ: {{ data.policyInfo[0].compsoccart }}</div>
                  </div>
                </b-col>

                <b-col md="12" sm="12" class="mt-2 p-2 content-header ">
                  <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">დამზღვევი</div>
                </b-col>
                <b-col md="3" sm="12" class="description p-2  pl-3">
                  სახელი გვარი | სახელწოდება
                </b-col>
                <b-col md="9" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.policyInfo[0].customerName }}</div>
                </b-col>
                <b-col md="3" sm="12" class="description p-2  pl-3">მისამართი</b-col>
                <b-col md="9" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.policyInfo[0].customerRegistrationAddress }}</div>
                </b-col>
                <b-col md="3" sm="12" class="description p-2  pl-3">პირადი ნომერი | ს.კ</b-col>
                <b-col md="9" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.policyInfo[0].customerSocCard }}</div>
                </b-col>
                <b-col md="3" sm="12" class="description p-2  pl-3">მობილური | ტელეფონი</b-col>
                <b-col md="9" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.policyInfo[0].customerPhoneNumber }}</div>
                </b-col>
                <template v-for="(item,index) in data.objectInfo" v-if="item.ID == 1">
                  <b-col md="12" sm="12" class="mt-2 p-2 content-header ">
                    <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">დაზღვეული {{ index + 1 }} |
                      მსესხებელი {{ index + 1 }}
                    </div>
                  </b-col>
                  <b-col md="3" sm="12" class="description p-2  pl-3">
                    სახელი გვარი | სახელწოდება
                  </b-col>
                  <b-col md="9" sm="12" class="value-background p-2  ">
                    <div class="text-center">{{ item.Name }}</div>
                  </b-col>
                  <b-col md="3" sm="12" class="description p-2  pl-3">მისამართი</b-col>
                  <b-col md="9" sm="12" class="value-background p-2  ">
                    <div class="text-center">{{ item.Saddress }}</div>
                  </b-col>
                  <b-col md="3" sm="12" class="description p-2  pl-3">პირადი ნომერი | ს.კ</b-col>
                  <b-col md="9" sm="12" class="value-background p-2  ">
                    <div class="text-center">{{ item.Soccart }}</div>
                  </b-col>
                  <b-col md="3" sm="12" class="description p-2  pl-3">მობილური | ტელეფონი</b-col>
                  <b-col md="9" sm="12" class="value-background p-2  ">
                    <div class="text-center">{{ item.Phone }}</div>
                  </b-col>
                </template>


                <b-col md="12" sm="12" class="description p-2 mt-2 pl-3">
                  და აგრეთვე ყველა ის ფიზიკური და/ან იურიდიული პირი და/ან პირთა გაერთიანება, რომლებმაც გააფორმეს
                  გენერალური და/ან საკრედიტო
                  ხელშეკრულება სს პროკრედიტ ბანკთან წინამდებარე პოლისში მითითებული დაზღვევის ობიექტის უზრუნველყოფით
                </b-col>

                <b-col md="12" sm="12" class="mt-2 p-2 content-header ">
                  <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">მოსარგებლე</div>
                </b-col>
                <b-col md="3" sm="12" class="description p-2  pl-3">
                  სახელი გვარი | სახელწოდება
                </b-col>
                <b-col md="9" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.policyInfo[0].customerName }}</div>
                </b-col>
                <b-col md="3" sm="12" class="description p-2  pl-3">მისამართი</b-col>
                <b-col md="9" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.policyInfo[0].customerRegistrationAddress }}</div>
                </b-col>
                <b-col md="3" sm="12" class="description p-2  pl-3">პირადი ნომერი | ს.კ</b-col>
                <b-col md="9" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.policyInfo[0].customerSocCard }}</div>
                </b-col>
                <b-col md="3" sm="12" class="description p-2  pl-3">მობილური</b-col>
                <b-col md="9" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.policyInfo[0].customerPhoneNumber }}</div>
                </b-col>


                <b-col md="12" sm="12" class="mt-2 p-2 content-header ">
                  <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">დაზღვევის ობიექტ(ებ)ი</div>
                </b-col>


                <b-col md="12" sm="12" class="mt-2 p-2 content-header " v-if="data.machinery[0].ProductID == 1">
                  <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">
                    {{ data.machinery[0].Product }}
                  </div>
                </b-col>
                <b-col md="12" sm="12" class="mt-2 p-2 content-header " v-if="data.machinery[0].ProductID == 2">
                  <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">
                    {{ data.machinery[0].Product }}
                  </div>
                </b-col>
                <b-col md="12" sm="12" class="mt-2 p-2 content-header " v-if="data.machinery[0].ProductID == 3">
                  <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">
                    {{ data.machinery[0].Product }}
                  </div>
                </b-col>

                <b-col md="3" sm="12" class="description p-2  pl-3">სახე</b-col>
                <b-col md="9" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.machinery[0].ObjectType }}</div>
                </b-col>
                <b-col md="3" sm="12" class="description p-2  pl-3">მისამართი</b-col>
                <b-col md="9" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.machinery[0].ObjectAddress }}</div>
                </b-col>
                <template v-if="data.machinery[0].ProductID == 1">
                  <b-col md="3" sm="12" class="description p-2  pl-3">საკადასტრო კოდი</b-col>
                  <b-col md="9" sm="12" class="value-background p-2  ">
                    <div class="text-center">{{ data.machinery[0].CadastralCode }}</div>
                  </b-col>
                  <b-col md="3" sm="12" class="description p-2  pl-3">მფლობელობის სახე</b-col>
                  <b-col md="9" sm="12" class="value-background p-2  ">
                    <div class="text-center">{{ data.machinery[0].propertykind }}</div>
                  </b-col>
                </template>

                <b-col md="3" sm="12" class="description p-2  pl-3">ჯამური საბაზრო ღირებულება</b-col>
                <b-col md="9" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.machinery[0].PropAmnt }}</div>
                </b-col>
                <b-col md="3" sm="12" class="description p-2  pl-3">ჯამური სადაზღვევო ღირებულება</b-col>
                <b-col md="9" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.machinery[0].SumPropAmnt }}</div>
                </b-col>


                <b-col md="12" sm="12" class="description p-3 mt-2">
                  დაზღვეული ობიექტის სხვა მონაცემები განისაზღვრება დამზღვევის მიერ შევსებული განაცხად-ანკეტით
                </b-col>


                <b-col md="12" sm="12" class="mt-2 p-2 content-header1 ">
                  <div class="col-md-9 col-sm-12 nino-mtavruli pl-2">დაზღვევის ტერიტორია</div>
                </b-col>
                <b-col md="12" sm="12" class=" p-2 value-background pl-3">
                  <div>ობიექტის ადგილმდებარეობის მიხედვით</div>
                </b-col>


                <div class="col-12   mt-2 p-0  border-green">

                  <div class="d-flex p-2 content-header1">
                    <div class="col-6 nino-mtavruli pl-2"> სადაზღვევო რისკები (ALL RISKS)</div>
                    <div class="col-3 text-center nino-mtavruli">სტატუსი</div>
                    <div class="col-3 text-center nino-mtavruli">ფრანშიზა</div>
                  </div>
                  <div class="col-md-12 row m-0 p-0" style="font-size: 14px; ">
                    <template v-for="item in data.risks">
                      <div class="col-6 border-bottom-mn border-right-mn">{{ item.Riskname }}</div>
                      <div class="col-3 border-bottom-mn border-right-mn text-center p-0">{{ item.RiskState }}</div>
                      <div class="col-3 border-bottom-mn text-center">{{ item.Noret }}</div>
                    </template>
                  </div>

                </div>

                <div class="mt-2 col-md-12 col-sm-12 ">
                  <b-row>
                    <b-col class="row">
                      <div class="col-md-6 description p-2 pl-3">წლიური პრემია</div>
                      <div class="col-md-6 p-2 border-mn">{{ data.policyInfo[0].insurancePremiums }}</div>
                    </b-col>
                    <b-col class="row">
                      <div class="col-md-6 description p-2 pl-3">გადახდის ჯერადობა</div>
                      <div class="nino-mtavruli col-md-6  p-2 border-mn">{{ data.policyInfo[0].payCount }}</div>
                    </b-col>

                  </b-row>
                </div>


                <b-col class="col-12 mt-2  description  bo mt-2 nino-mtavruli p-2 pl-3">
                  გადახდის გრაფიკი
                </b-col>

                <div class="col-12 mt-2 m-0 d-flex justify-content-between payment">
                  <div class="payment-block row p-0  border-green mr-4">
                    <div class="col-6 border-value payment-title nino-mtavruli border-bottom-mn border-right-mn"
                         style="background-color: #E0E0E0">
                      თარიღი
                    </div>
                    <div class="col-6 border-value payment-title nino-mtavruli border-bottom-mn txt-center-sm"
                         style="background-color: #E0E0E0">
                      თანხა
                    </div>
                    <template
                        v-for="payment in data.policyInfo[0].propayment.slice(0, Math.round( data.policyInfo[0].propayment.length/2))">
                      <td class="col-6 border-bottom-mn border-right-mn pl-sm">
                        {{ payment.payDate }}
                      </td>
                      <td class="col-6 border-bottom-mn txt-center-sm">
                        {{ payment.payment }}
                      </td>
                    </template>
                  </div>

                  <div class="payment-block row p-0 border-green" v-if="data.policyInfo[0].propayment.length>=2">
                    <div class="col-6  border-value payment-title nino-mtavruli border-bottom-mn border-right-mn"
                         style="background-color: #E0E0E0">
                      თარიღი
                    </div>
                    <div class="col-6  border-value payment-title nino-mtavruli border-bottom-mn txt-center-sm"
                         style="background-color: #E0E0E0">
                      თანხა
                    </div>
                    <template
                        v-for="payment in data.policyInfo[0].propayment.slice(Math.round(data.policyInfo[0].propayment.length/2), data.policyInfo[0].propayment.length)">
                      <td class="col-6 border-bottom-mn border-right-mn pl-sm">
                        {{ payment.payDate }}
                      </td>
                      <td class="col-6 border-bottom-mn txt-center-sm">
                        {{ payment.payment }}
                      </td>
                    </template>
                  </div>

                </div>


                <b-col md="12" sm="12" class="mt-2 p-2 content-header1 ">
                  <div class="col-md-9 col-sm-12 nino-mtavruli pl-2">სადაზღვევო პერიოდი</div>
                </b-col>
                <div class="d-flex col-12 p-0">
                  <b-col md="3" sm="12" class=" p-2 value-background-rb" style="background-color: #E0E0E0">
                    <div class="nino-mtavruli pl-2">დან</div>
                  </b-col>
                  <b-col md="3" sm="12" class=" p-2 value-background">
                    <div>{{ data.policyInfo[0].fromDate }}</div>
                  </b-col>
                  <b-col md="3" sm="12" class=" p-2 value-background-rb " style="background-color: #E0E0E0">
                    <div class="nino-mtavruli pl-2">ჩათვლით</div>
                  </b-col>
                  <b-col md="3" sm="12" class=" p-2 value-background">
                    <div>{{ data.policyInfo[0].toDate }}</div>
                  </b-col>
                </div>


                <b-col md="12" sm="12" class="mt-2 p-2 content-header1 ">
                  <div class="col-md-9 col-sm-12 nino-mtavruli pl-2"> შენიშვნებისა და სპეციალური შეთანხმებების ბლოკი
                  </div>
                </b-col>
                <b-col md="12" sm="12" class="value-background">
                    {{data.policyInfo[0].addnote}}
                </b-col>

                <b-col md="12" sm="12" class="p-2 content-header mt-2 ">
                  <div class="col-md-12 col-sm-12 text-center nino-mtavruli">პოლისის გაცემის საფუძვლები</div>
                </b-col>
                <b-col md="5" sm="12" class="description p-2 ">ქონების საკრედიტო დაზღვევის პირობები ვერსია 1.20</b-col>
                <b-col md="7" sm="12" class="value-background-lrb p-2 ">
                  <div class="text-center">
                    <div style="cursor: pointer; color: -webkit-link; " @click="openLink()">
                      {{ data.policyInfo[0].condition }}
                    </div>
                  </div>
                </b-col>
                <b-col md="5" sm="12" class="description p-2 ">გენერალური ხელშეკრულება</b-col>
                <b-col md="7" sm="12" class="value-background-lrb p-2 ">
                  <div class="text-center">
                    <div>{{ data.policyInfo[0].contnum }}</div>
                  </div>
                </b-col>

                <b-col md="12" sm="12" class="border-green p-2 mt-2">
                  <div class="">
                    მე დამზღვევი/დაზღვეული, ვაცნობიერებ, რომ პოლისი შეიცავს ჩემს მიერ მოწოდებულ მონაცემებს და
                    ვადასტურებ, რომ ისინი სრულყოფილი
                    და სწორია. აგრეთვე, ვაცხადებ, რომ დეტალურად განმემარტა სს "არდი დაზღვევა"-ს ქონების საკრედიტო
                    დაზღვევის პირობები, ვეთანხმები და
                    ვკისრულობ მასში გათვალისწინებული ვალდებულებების სრულად შესრულების ვალდებულებას. ამასთან, თანახმა
                    ვარ, რომ მრავალწლიანი
                    სესხის შემთხვევაში, პოლისი განახლდეს ავტომატურად, გარდა იმ შემთხვევისა, თუ არ იცვლება(იზრდება)
                    პოლისით გათვალისწინებული
                    სადაზღვევო გადასახადი (სადაზღვევო პრემია). დაზღვეული/მსესხებელი უფლებამოსილებას ანიჭებს ბანკს, მისი
                    ნებისმიერი ანგარიშიდან,
                    მისი თანხმობის გარეშე, ჩამოწეროს სადაზღვევო პრემიის თანხა და განახორციელოს ანგარიშსწორება სადაზღვევო
                    კომპანიასთან.
                    სადაზღვევო კომპანიასთან ანგარისსწორება ხდება ეროვნულ ვალუტაში (ლარში), თუ მსესხებლის ანგარიშზე
                    არსებული თანხა სხვა ვალუტაშია,
                    ბანკი უფლებამოსილია მსესხებლის ხარჯზე მოახდინოს სავალუტო ერთეულიდან 'მეორეში თანხის კონვერტაცია,
                    ანგარიშიდან თანხის
                    ჩამოწერის დღისთვის ბანკში მოქმედი კომერციული კურსის შესაბამისად, ასევე ჩამოწეროს კონვერტაციის
                    საკომისიო (არსებობის
                    შემთხვევაში).
                  </div>
                </b-col>

                <b-col md="12" sm="12" class="mt-2 p-2 content-header1">
                  <div class="col-md-9 col-sm-12 nino-mtavruli pl-2 d-flex">
                    <b-form-checkbox v-model="checked" :disabled="role == 0" class="d-md-flex justify-content-md-around"
                                     size="lg"></b-form-checkbox>
                    <div class="mt-1" style="font-size: 16px;">
                      გავეცანი სს "არდი დაზღვევა"-ს ქონების საკრედიტო დაზღვევის პირობებს ბმულზე :
                      <a v-bind:href='data.policyInfo[0].condition'
                         target="_blank">{{ data.policyInfo[0].condition }}</a>
                    </div>
                  </div>
                </b-col>

                <div class="mt-3 col-md-12 col-sm-12 d-flex p-0  ">
                  <b-button variant="success" class="mr-3 accept-text approve-cancel-btn" :disabled="!checked"
                            @click="submit">პოლისის შექმნა
                  </b-button>
                  <b-button @click="Denial" class="accept-text approve-cancel-btn" style="background-color: darkgray;">
                    პოლისის უარყოფა
                  </b-button>

                </div>

                <template v-if="role == 0 || role == 2">
                  <b-col md="12" sm="12" class="p-2 content-header mt-4 mt-sm">
                    <div class="col-md-12 col-sm-12 text-center nino-mtavruli">ხელმოწერები</div>
                  </b-col>
                  <signature :roleid="this.role" class="col-12"/>
                </template>


                <b-modal v-model="denial" size="sm" ok-title="დასრულება" ok-only @ok="reject"
                         title="უარყოფის მიზეზი">
                  <b-form-checkbox id="checkbox-2"
                                   v-model="rejectStatus"
                                   class="mt-3"
                                   value="56">
                    ხარვეზი მონაცემებში
                  </b-form-checkbox>
                  <b-form-checkbox id="checkbox-3"
                                   v-model="rejectStatus"
                                   class="mt-3"
                                   value="54">
                    პირობის უარყოფა
                  </b-form-checkbox>
                </b-modal>

                <!--<b-modal v-model="approvestatus" centered size="lg" hide-footer>
                <div class="d-flex justify-content-center" v-if="loadingSpinner" style="color:red; text-align:center">
                    <div class="item-1"></div>
                    <div class="item-2"></div>
                    <div class="item-3"></div>
                    <div class="item-4"></div>
                    <div class="item-5"></div>
                </div>
            </b-modal>-->

                <b-modal v-model="status1" size="lg" ok-title="დასრულება" ok-only @ok="finish">
                  სამწუხაროდ, თქვენი ქონების საკრედიტო დაზღვევის პოლისი არ გააქტიურდა. 
                  დაზღვევის გასაფორმებლად, დაუკავშირდით თქვენს პირად მენეჯერს
                  {{ this.data.policyInfo[0].nmG_NAME_A }} {{ this.data.policyInfo[0].mnG_LASTNAME }},
                  <a :href='"tel:+995"+this.data.mnG_PHONE'>{{ this.data.policyInfo[0].mnG_PHONE }}</a>,
                  <a :href='"mailto:"+this.data.mnG_EMAIL'>{{ this.data.policyInfo[0].mnG_EMAIL }}</a>
                </b-modal>
              </b-row>
            </b-col>
          </div>
        </div>
      </div>
      </tbody>

      <tfoot class="">
      <div class="m-0 mt-5">
        <div class="col-10 offset-sm-0  offset-md-1 offset-lg-1 pr-0">
          <div class="d-flex justify-content-between  pb-4 m-lg-n3">
            <img src="../assets/img/ardi-logo.svg" width="120">
            <img src="../assets/img/slogan.svg" width="250" class="pl-4 pr-md-4 footer-pic">
          </div>
        </div>
      </div>
      </tfoot>
    </table>


    <b-modal ref="counter-modal"
             title="ინფორმაცია"
             id="info-modal"
             hide-footer
             v-b-modal.modal-sm>
      <p>დაფიქსირდა შეცდომა პოლისის ჩაწერისას.</p>
      <p>გთხოვთ <a>სცადეთ თავიდან</a> <b>{{ minutes }} წამში.</b></p>
      <b-button :disabled="minutes!==0"
                variant="success"
                @click="submit(); countdownSpinner=true">
        დადასტურება
        <b-spinner v-if="countdownSpinner" small label="Small Spinner"></b-spinner>
      </b-button>
    </b-modal>

    <b-modal id="info-modal2"
             ref="operation-modal"
             title="ინფორმაცია"
             hide-footer
             v-b-modal.modal-sm>
      <p>პოლისის რეგისტრაცია შეუძლებელია მოცემული პარამეტრებით. გთხოვთ გადაამოწმოთ პოლისში მითითებული ინფორაცია ან
        დაუკავშირდეთ მენეჯერს.</p>
      <b-button @click="reloadPage()" variant="light">პოლისის ნახვა</b-button>
    </b-modal>

  </div>
</template>

<script>
import Signature from "@/Procredit/components/Signature";
import Success from "@/Procredit/components/Success";

export default {
  name: "ContractPreview",
  components: {
    Signature,
    Success
  },
  data() {
    return {
      data: null,
      rejectStatus: null,
      checked: null,
      loadingSpinner: true,
      role: 1,
      cont: this.$route.params.cont,
      cust: this.$route.params.cust,
      denial: false,
      status: false,
      status1: false,
      //approvestatus: false,
      response: '',
      showSuccess: false,
      statusApprove: 0,
      canceledLink: 0,
      minutes: 19,
      countdown: null,
      countdownSpinner: false,
    }
  },

  mounted() {
    this.$http.get(`/policy/CheckCanceledProcredit/${this.$route.params.rowid}/${this.$route.params.cont}`).then(r => {
      console.log("canceledLink", r.data);
      this.canceledLink = r.data
    }).catch((e) => {
      console.log(e)
    }),

        this.$http.get(`/policy/CheckApproveProcredit/${this.$route.params.rowid}/${this.$route.params.cont}`).then(r => {
          this.statusApprove = r.data
        }).catch((e) => {
          console.log(e)
        }),
        this.$http.get(`/policy/GetStatusPro/${this.$route.params.rowid}`).then(r => {
          if (r.data == 0) {
            this.role = 0;
            this.checked = true;
          } else if (r.data == 2) {
            this.role = 2;
            this.checked = true;
          }
        }).catch((e) => {
          console.log(e)
        }),


        this.$http.get(`/policy/GetProInfo/${this.cont}/${this.cust}`).then(r => {
          this.data = r.data;
          console.log(r.data);
        }).catch((e) => {
          console.log(e)
        })

  },

  methods: {
    reloadPage() {
      this.$refs['operation-modal'].hide();
    },
    showCounterModal: function () {
      this.$refs['counter-modal'].show();

      this.minutes = 19;
      clearInterval(this.countdown);

      this.countdown = setInterval(() => {
        if (this.minutes != 0)
          this.minutes--;
      }, 1000);
    },
    openLink: function () {
      window.open(this.data.policyInfo[0].condition, "_blank");
    },
    Denial() {
      this.denial = true
    },
    submit() {
      let that = this;
      document.body.classList.toggle('loader-overlay')
      //this.loadingSpinner = true;
      //this.approvestatus = true;
      this.$http.post('/policy/CreatePolicyProcredit', {
        Cust: this.$route.params.cust,
        Cont: this.$route.params.cont,
        RowId: this.$route.params.rowid,
        Policy: this.data.policyInfo[0].policyInsuranceProduct,
        VPolicy: this.data.policyInfo[0].vPolicy,
        ControllerName: 'Pro',
        Status: 1
      }).then((r) => {
        console.log("r.data", r.data)

        if (r.data.isDeadlocked) {
          this.showCounterModal();
          this.countdownSpinner = false;
        } else {
          if (r.data.isSuccess) {
            this.response = r.data.msg
            this.showSuccess = true;
          } else {
            this.$refs['operation-modal'].show();
          }
        }
        //this.approvestatus = false;
        //this.loadingSpinner = false;

      }).catch((e) => {
        console.log(e)
        alert("შეცდომა პოლისის ჩაწერისას");
      })
      if (this.response == '') {
        setTimeout(() => {
          //this.approvestatus = false;
          //this.loadingSpinner = false;
          this.showSuccess = true;
        }, 2000)
      }

    },

    reject() {
      this.status1 = true
      this.$http.post('/policy/Reject', {
        PolId: this.$route.params.cont,
        Cust: this.$route.params.cust,
        Cont: this.$route.params.cont,
        Policy: this.data.policyInfo[0].policyInsuranceProduct,
        PolicyStart: this.data.policyInfo[0].fromDate,
        PolicyEnd: this.data.policyInfo[0].toDate,
        ClientName: this.data.policyInfo[0].customerName,
        ClientPhone: this.data.policyInfo[0].customerPhoneNumber,
        ManagerName: this.data.policyInfo[0].nmG_NAME_A + ' ' + this.data.policyInfo[0].mnG_LASTNAME,
        ManagerPhone: this.data.policyInfo[0].mnG_PHONE,
        ManagerEmail: this.data.policyInfo[0].mnG_EMAIL,
        ControllerName: 'pro',
        Status: 2,
        RowId: this.$route.params.rowid,
        RejectCode: parseInt(this.rejectStatus)
      }).then((r) => {
        console.log(r.data)
      }).catch((e) => {
        console.error(e)
      })
      console.log("reject")

    },
    finish() {
      console.log("finish")
      window.location = 'https://ardi.ge/'
    }

  }
}
</script>

<style scoped>
@import "~bpg-nino-mtavruli";

.nino-mtavruli {
  font-family: "BPG Nino Mtavruli", sans-serif;
}

.approve-cancel-btn {
  width: 50%;
  height: 130%;
  font-size: 21px;
  border-radius: 10px;
}

.border-green {
  border: 2px solid #00a987 !important;
}

.pol-number {
  font-size: 17px;
  font-weight: bold;
}

.header-text {
  font-size: 32px;
  font-weight: bold;
  color: #005745;
  height: 71px;
  line-height: 100px;
  text-align: center;
}

.description-box {
  background-color: #00a987;
  color: #fff;
}

.print-body {
  margin-bottom: 5rem;
}

.value-background {
  border-bottom: 1px solid #b0b1b3 !important;
  border-right: 1px solid #b0b1b3 !important;
  border-left: 1px solid #b0b1b3 !important;
  font-size: 14px;
}

.value-background-rb {
  border-bottom: 1px solid #b0b1b3 !important;
  border-left: 1px solid #b0b1b3 !important;
  font-size: 14px;
}

.value-background-lrb {
  border-bottom: 1px solid #b0b1b3 !important;
  border-right: 1px solid #b0b1b3 !important;
  border-left: 1px solid #b0b1b3 !important;
  font-size: 14px;
}

.border-mn {
  border: 1px solid #b0b1b3 !important;
  font-size: 14px;
}

.content-header {
  background-color: #005745;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

.content-header1 {
  background-color: #007961;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

.description {
  background-color: #007961;
  color: #fff;
  font-size: 14px;
}

.description-top {
  background-color: #00A788;
  color: #fff;
}


.border-bottom-mn {
  border-bottom: 1px solid #b0b1b3 !important;

}

.border-right-mn {
  border-right: 1px solid #b0b1b3 !important;
}


.print-body {
  margin-bottom: 5rem;
}

.payment-block {
  width: 51%;
}

table {
  width: 100%;
}


.pay-border-left {
  border-left: 1px solid #41A546;
}

.pay-head-border {
  border-collapse: collapse;
  border-bottom: 1px solid #b0b1b3 !important;
  border-right: 1px solid #b0b1b3 !important;
}


#print-header {
  padding: 15px 0;
  display: table-header-group;
}


.payment-md-border {
  border: 1px solid #00A886;
  border-collapse: collapse;
  font-size: 10pt;
}

.md-text {
  width: 62%
}

.height-sm {
  height: 66px;
}

.footer-pic {
  width: 330px;
}


@media (max-width: 500px) {
  .header_logo_property {
    width: 100%;
  }

  .sm-text {

    width: 100%
  }

  .hide-logo-sm {
    display: none;
  }

  .height-sm {
    height: 77px;
  }

  .footer-pic {
    width: 250px;
  }

  .payment-block {
    width: 53%;
  }

  .pl-sm {
    padding-left: .5rem !important;

  }

  .txt-center-sm {
    text-align: center !important;
  }

  .mt-sm {
    margin-top: 32px !important;
  }

  .header-text {
    font-size: 21px;
  }

}


.loader {
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -ms-flex-preferred-size: 25%;
  flex-basis: 25%;
  max-width: 25%;
  height: 200px;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  display: none;
}

.loader-overlay {
  overflow: hidden
}

.loader-overlay .loader {
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 333;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 99999999;
}

.loader-overlay {
  position: relative;
  width: 100%;
  height: 100%;
  /* background: #ccc; */
  z-index: 999;
}

.loader-overlay:after {
  position: fixed;
  content: '';
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #efefef91;
  z-index: 9999999;
}

.square-spin > div {
  width: 50px;
  height: 50px;
  background: #00A987;
  -webkit-animation: square-spin 3s 0s cubic-bezier(.09, .57, .49, .9) infinite;
  animation: square-spin 3s 0s cubic-bezier(.09, .57, .49, .9) infinite;
}

.square-spin > div img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@-webkit-keyframes square-spin {
  25% {
    -webkit-transform: perspective(100px) rotateX(180deg) rotateY(0);
    transform: perspective(100px) rotateX(180deg) rotateY(0);
  }

  50% {
    -webkit-transform: perspective(100px) rotateX(180deg) rotateY(180deg);
    transform: perspective(100px) rotateX(180deg) rotateY(180deg);
  }

  75% {
    -webkit-transform: perspective(100px) rotateX(0) rotateY(180deg);
    transform: perspective(100px) rotateX(0) rotateY(180deg);
  }

  100% {
    -webkit-transform: perspective(100px) rotateX(0) rotateY(0);
    transform: perspective(100px) rotateX(0) rotateY(0);
  }
}

</style>